import { storeFnCreator } from '@/system/init/init-store';
import report from './module/report';

const loadConfig = pid => {
  let c = null;
  try {
    c = require(`../config/${pid}.js`);
  } catch (err) {
    c = require('../config/default.js');
  }

  return c;
};

const initStore = {
  state: {
    pid: 1001,
    gray: '0'
  },
  mutations: {
    setThemeGray (state, payload) {
      state.gray = payload;
    }
  },
  modules: {
    report
  }
};

export function createStore () {
  return storeFnCreator(loadConfig, initStore);
};



// WEBPACK FOOTER //
// ./src/projects/hsbpc/store/index.js